/* eslint react/no-danger: 0 */ // --> OFF

import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./styles.less";

const createReactMarkupObj = html => ({
  __html: html
});

const InnerHTML = ({ html, className, callbackRef, disablePreLine }) => {
  let htmlMarkup = createReactMarkupObj(html);
  return (
    <div
      dangerouslySetInnerHTML={htmlMarkup}
      className={cx({ [styles.htmlMarkup]: !disablePreLine }, className)}
      ref={callbackRef}
    />
  );
};

InnerHTML.defaultProps = {
  className: "",
  disablePreLine: false
};

InnerHTML.propTypes = {
  html: PropTypes.string.isRequired,
  className: PropTypes.string,
  callbackRef: PropTypes.func,
  disablePreLine: PropTypes.bool
};

export default InnerHTML;



// WEBPACK FOOTER //
// ./src/components/common/RawHTML/RawHTML.js